import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setEditId, selectPhoneNumberPriceById } from "src/store/callrecorder/phoneNumberPricesSlice";
import { fetchPhoneNumberPrice } from "src/actions/callrecorder/phoneNumberPricesActions";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "src/componets/SummaryShow";
import Tabs from "src/componets/Tabs";
import { ButtonEdit } from "src/componets/Buttons";
import Edit from "./Edit";
import SidebarShow from "./_partials/_SidebarShow";
import PriceHistoryListTable from "../PhoneNumberPriceHistories/_partials/_ListTable";
import Icon from "src/componets/Icon";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const record = useAppSelector(state => id ? selectPhoneNumberPriceById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchPhoneNumberPrice(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (record) {
      dispatch(setEditId(record.id));
    }
  }

  const filterParams = useMemo(() => ({ phone_number_price_id: id }), [id]);

  return (
    <PageLayout className='v-phone-number-prices-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            record &&
              <SummaryShow
                icon={<Icon icon="fa-solid fa-tag" />}
                title={`+${record.prefix} ${record.country_code} (${record.phone_number_type})`}
                createdAt={record.created_at}
                updatedAt={record.updated_at}
                actions={[
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />
                ]}
                className='v-mb-15'
              />
          }
        </div>

        <Tabs
          paramsKey='tab'
          defaultActiveKey='history'
          destroyInactiveTabPane={true}
          items={[
            { label: 'History', key: 'history', children: <PriceHistoryListTable filterParams={filterParams} /> },
          ]}
        />
      </div>

      <Edit />

      <SidebarShow record={record} />
    </PageLayout>
  )
}

export default Show;
